"use client";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CountUp from "react-countup";
import {
  faComputer,
  faShip,
  faServer,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";

export default function OurAchievements(){
    return(<>
    
    <Row style={{ margin: "0", padding: "0" }}>
        <Container
          fluid
          style={{
            minHeight: "250px",
            backgroundColor: "#ebffff",
            backgroundPosition: "0",
            backgroundSize: "cover",
            backgroundImage: `url(/Images/white-concrete-wall.jpg)`,
          }}
        >
          <Container>
            <Col xs={12}>
              <h2 className="m-t-50 mb-3 font-bold fs-35">Proven Performance Across the Industry</h2>
            </Col>
            <Row className="pt-5 pb-5">
              <motion.div
                initial={{ opacity: 0, scale: 0.2 }}
                whileInView={{ opacity: 1, scale: 1 }}
                animate={{}}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
              >
                <Row>
                  <Col xs={12} md={4} className="mb-5 mt-5">
                    <Row>
                      <Col xs={12} className="fs-35 font-bold mb-2">
                        Total Installation
                      </Col>
                      <Col xs={12} className="text-center">
                        <FontAwesomeIcon
                          icon={faComputer}
                          className="fs-30 CounterIcon float-start"
                          style={{ marginLeft: "10%" }}
                        />
                     
                        <CountUp
                          start={0}
                          end={1100}
                          suffix=" +"
                          duration={3}
                          scrollSpyOnce={true}
                          enableScrollSpy={true}
                        >
                          {({ countUpRef }) => (
                            <span
                              className="fs-50 font-bold"
                              style={{ color: "#212529" }}
                              ref={countUpRef}
                            />
                          )}
                        </CountUp>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} md={4} className="mb-5 mt-5">
                    <Row>
                      <Col xs={12} className="fs-35 font-bold mb-2">
                        CO<sub>2</sub> Emmissions Reduced
                      </Col>
                      <Col xs={12} className="text-center">
                        <FontAwesomeIcon
                          icon={faShip}
                          className="fs-30 CounterIcon float-start"
                          style={{ marginLeft: "5%" }}
                        />
                     
                        <CountUp
                          start={0}
                          end={50000}
                          suffix="+ MTs"
                          duration={3}
                          scrollSpyOnce={true}
                          enableScrollSpy={true}
                        >
                          {({ countUpRef }) => (
                            <span
                              className="fs-50 font-bold"
                              style={{ color: "#212529" }}
                              ref={countUpRef}
                            />
                          )}
                        </CountUp>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} md={4} className="mb-5 mt-5">
                    <Row>
                      <Col xs={12} className="fs-35 font-bold mb-2">
                        Email Traffic Reduced
                      </Col>
                      <Col xs={12} className="text-center">
                        <FontAwesomeIcon
                          icon={faServer}
                          className="fs-30 CounterIcon float-start"
                          style={{ marginLeft: "10%" }}
                        />
                     
                       <CountUp
                          start={0}
                          end={250000}
                          suffix=" +"
                          duration={3}
                          scrollSpyOnce={true}
                          enableScrollSpy={true}
                        >
                          {({ countUpRef }) => (
                            <span
                              className="fs-50 font-bold"
                              style={{ color: "#212529" }}
                              ref={countUpRef}
                            />
                          )}
                        </CountUp>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </motion.div>
            </Row>
          </Container>
        </Container>
      </Row>
    </>)
}